import React from "react";
import { bannerShell, pageBannerFrame, pageBannerImage } from "../lib/banner";
import { optimizePageBannerImageUrl } from "../lib/image";

export default function PageBanner({
  image,
  isLoading = false,
  optimizeImage = true,
}) {
  const rawImage = image?.trim() || null;
  const bgImage = optimizeImage
    ? optimizePageBannerImageUrl(rawImage) || rawImage
    : rawImage;

  return (
    <section className={`${bannerShell} ${pageBannerFrame}`} aria-label="Page banner">
      {isLoading && !bgImage ? (
        <div className="h-[280px] sm:h-[360px] md:h-[500px] bg-neutral-800 animate-pulse" aria-hidden="true" />
      ) : null}

      {bgImage ? (
        <img
          src={bgImage}
          alt=""
          className={pageBannerImage}
          fetchPriority="high"
          decoding="async"
          aria-hidden="true"
        />
      ) : null}
    </section>
  );
}
